import { combineReducers } from 'redux';

import customer from './customer';
import tag from './tag';

export default combineReducers({
  customer,
  tag, 
});
